import React from 'react'
import styled from '@emotion/styled'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapper'
import ColorButton from 'src/components/atoms/ColorButton'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import { Typography } from 'src/components/atoms/Typography'
import { SNSLink } from 'src/components/atoms/SNSLink'
import { NoLineBreak } from 'src/components/atoms/NoLineBreak'
// images
import LogoImage from 'src/images/shared/commmune-logo-white.png'
import CVContact from 'src/images/shared/cv-contact.svg'
import CVCatalog from 'src/images/shared/cv-catalog.svg'
import twitterIcon from 'src/images/shared/twitter.svg'
import facebookIcon from 'src/images/shared/facebook.svg'

type CVItemProps = {
  first?: boolean
}

class Footer extends React.Component {
  render() {
    return (
      <Container>
        <BackGroundBlue>
          <ContentsWrapper>
            <Text>
              <NoLineBreak>企業とユーザーが</NoLineBreak>
              <NoLineBreak>融け合う</NoLineBreak>
              <NoLineBreak>コミュニティサクセス</NoLineBreak>
              <NoLineBreak>プラットフォーム</NoLineBreak>
            </Text>
            <Logo src={LogoImage} />
            <CVWrapper>
              <CVItem first>
                <CV src={CVContact} />
                <ColorButton
                  text="資料ダウンロード"
                  size="medium"
                  to="/whitepapers/commmune_introduction/"
                  arrow
                  outer={false}
                />
              </CVItem>
              <CVItem>
                <CV src={CVCatalog} />
                <ColorButton
                  text="お問い合わせ"
                  size="medium"
                  color="white"
                  to="/contact/"
                  arrow
                />
              </CVItem>
            </CVWrapper>
          </ContentsWrapper>
        </BackGroundBlue>
        <UnderContents>
          <LinkLine>
            <ContentsWrapper css={[LinkWrapper]}>
              <LinkText href="/company/">運営企業</LinkText>
              <LinkText
                href="https://commmune-careers.studio.site/"
                target="_blank"
              >
                採用情報
              </LinkText>
              <LinkText href="https://commmune.com">
                <NoLineBreak>既にアカウントを</NoLineBreak>
                <NoLineBreak>お持ちの方はこちら</NoLineBreak>
              </LinkText>
              <LinkText href="/membership_agreement/">
                お客さま向け規約
              </LinkText>
              <LinkText href="/user_agreement/">ユーザー向け規約</LinkText>
              <LinkText href="/privacy_policy/">プライバシーポリシー（個人情報保護方針）</LinkText>
              <LinkText href="/security_policy/">情報セキュリティ方針</LinkText>
              <LinkText href="https://community.commmune.com/view/box?boxId=knowledgeBase001&categoryIndex=99">
                ヘルプページ
              </LinkText>
              <LinkText href="https://commmune.hatenablog.com/">
                開発者ブログ
              </LinkText>
            </ContentsWrapper>
          </LinkLine>
          <SNSLinkLine>
            <SNSLink
              image={twitterIcon}
              linkTo="https://twitter.com/commmunejp"
              alt="commmuneのtwitterアカウントページ"
            />
            <SNSLink
              image={facebookIcon}
              linkTo="https://www.facebook.com/commmunejp/"
              alt="commmuneのfacebookアカウントページ"
            />
          </SNSLinkLine>
          <Rights as="p">©️Commmune Inc. All rights reserved</Rights>
        </UnderContents>
      </Container>
    )
  }
}

const SNSLinkLine = styled.div`
  display: flex;
  justify-content: center;
  height: 30px;
  width: 100%;
  margin: 20px 0 0;
`

const Container = styled.div`
  position: relative;
`

const BackGroundBlue = styled.div`
  position: relative;
  background-color: #22475d;
  text-align: center;
  padding: ${Styles.spacing[11]} 0;
  @media screen and (min-width: ${BreakPoint.MOBILE}) {
    padding: ${Styles.spacing[14]} 0;
  }
`

const UnderContents = styled.div`
  position: relative;
  padding-bottom: 20px;
`

const Text = styled(Typography)`
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.7;
  letter-spacing: 1.6px;
  color: #ffffff;
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    font-size: 15px;
  }
`

const Logo = styled.img`
  width: 100%;
  max-width: 360px;
  margin-top: 30px;
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    max-width: 250px;
  }
`

const CV = styled.img`
  width: 100%;
  max-width: 170px;
  justify-content: space-between;
  @media screen and (max-width: ${BreakPoint.TABLET_MIN_WIDTH}) {
    height: 150px;
  }
`

const CVWrapper = styled.div`
  display: flex;
  justify-content: center;

  padding: ${Styles.spacing[6]} 0 0;
  @media screen and (min-width: ${BreakPoint.MOBILE}) {
    padding: ${Styles.spacing[11]} 0 0;
  }
  @media screen and (max-width: ${BreakPoint.TABLET}) {
    justify-content: center;
  }
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    flex-direction: column;
    gap: ${Styles.spacing[8]};
  }
`

const CVItem = styled.div<CVItemProps>`
  display: flex;
  align-items: center;
  gap: ${Styles.spacing[10]};
  border-right: ${({ first }) => (first ? 'solid 1px #ffffff' : '')};
  padding-right: ${({ first }) => (first ? '50px' : '0px')};
  padding-left: ${({ first }) => (first ? '0px' : '50px')};
  @media screen and (max-width: ${BreakPoint.LAPTOP}) {
    flex-direction: column;
    padding-right: ${({ first }) => (first ? '30px' : '0px')};
    padding-left: ${({ first }) => (first ? '0px' : '30px')};
  }
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    padding: 0;
    border: none;
  }
`

const LinkLine = styled(Typography)`
  background-color: #e8ecee;
`

const LinkWrapper = `
display: flex;
justify-content: space-between;
max-width:1200px;
padding: 40px 0;
@media screen and (max-width: ${BreakPoint.TABLET_MAX_WIDTH}) {
  margin: 0 10%;
  padding: 20px 0;
  display: grid;
  grid-template-columns: max-content max-content max-content max-content;
}
@media screen and (max-width: ${BreakPoint.TABLET_MIN_WIDTH}) {
  grid-template-columns: 1fr 1fr;
}
`

const LinkText = styled.a`
  font-family: inherit;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.33;
  letter-spacing: 0.96px;
  text-align: left;
  color: #444444;
  text-decoration: none;
  margin: 0 5px;
`

const Rights = styled(Typography)`
  font-family: inherit;
  font-size: 9px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 3.11;
  letter-spacing: 0.72px;
  text-align: center;
  color: #444444;
  padding: 20px;
`

export default Footer
